// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1Gnw1","colMaxWidth":"Table_colMaxWidth__Fm8ab"};